import classNames from 'classnames';

import { SKELETON_BY_TAB } from 'containers/admin/clients/client/tabs-components/critical-populations/critical-populations.constants';
import type { CaptureListTab } from 'containers/admin/clients/client/tabs-components/critical-populations/critical-populations.types';

interface CaptureListSkeletonProps {
  tab: CaptureListTab;
}

const CaptureListSkeleton = ({ tab }: CaptureListSkeletonProps) => {
  const {
    cardCount,
    cardHeightClass,
    hasReasonBlock,
    hasToolbar,
    buttonCount,
  } = SKELETON_BY_TAB[tab];

  return (
    <div
      className={classNames('flex flex-col gap-3', {
        'mt-1': !hasToolbar,
      })}
      aria-busy="true"
      data-testid="capture-list-skeleton"
    >
      {hasToolbar && (
        <div
          className="flex items-end justify-between"
          data-testid="capture-list-skeleton-toolbar"
        >
          <div className="h-5 w-[200px] rounded bg-gray-100" />
          <div className="h-10 w-[136px] rounded bg-gray-100" />
        </div>
      )}
      {Array.from({ length: cardCount }, (_, index) => (
        <div
          key={index}
          className={classNames(
            'overflow-hidden rounded-[10px] border border-navy-100 bg-white shadow-[0_1px_2px_rgba(0,0,0,0.05)]',
            cardHeightClass
          )}
        >
          <div className="flex flex-col gap-1 px-4 pb-3 pt-4">
            <div className="flex gap-1">
              <div className="h-5 w-[65px] rounded bg-gray-100" />
              <div className="h-5 w-20 rounded bg-gray-100" />
            </div>
            <div className="h-6 w-[380px] max-w-full rounded bg-gray-200" />
            <div className="h-3 w-[425px] max-w-full rounded bg-gray-100" />
            <div className="h-3 w-[100px] rounded bg-gray-200" />
            {hasReasonBlock && <div className="h-16 rounded bg-gray-100" />}
          </div>
          <div className="flex gap-3 px-4 pb-4 pt-3">
            {Array.from({ length: buttonCount }, (_, buttonIndex) => (
              <div
                key={buttonIndex}
                className="h-8 w-[120px] rounded bg-gray-100"
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CaptureListSkeleton;
